import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import { request } from '@/api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import less from 'less';
import "overlayscrollbars/css/OverlayScrollbars.css";
import OverlayScrollbars from "overlayscrollbars";
import { OverlayScrollbarsPlugin } from "overlayscrollbars-vue";
import conva from "@/config/htmltoimage.js"
Vue.prototype.$toImage = conva;
Vue.use(OverlayScrollbarsPlugin);
Vue.use(OverlayScrollbars);
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
Vue.use(less)
Vue.use(ElementUI)
Vue.config.productionTip = false
/**
 * @description 全局注册请求变量
 */
 Vue.prototype.$request = request
 // eslint-disable-next-line
const _hmt = _hmt || [];
// eslint-disable-next-line
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?6a206bb044ab38f6e1b0e96a5f4afdfa";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
//runtime
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")

